import React from 'react';
import { Navigate } from 'react-router-dom';
import { USER_ROLES } from '../constants';
import { canAccessRoute } from '../utils/moduleAccess';

const RoleBasedRoute = ({ children, path }) => {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));

    if (!currentUser) {
        return <Navigate to="/login" replace />;
    }

    const userRole = currentUser?.role?.name;

    if (!canAccessRoute(currentUser, path)) {
        if (userRole === USER_ROLES.SUPER_ADMIN) {
            return <Navigate to="/platform-billing" replace />;
        }
        // If not authorized for the requested path, redirect to Applications which is common for most workers
        // Surveyor role should be redirected to documents
        if (userRole === USER_ROLES.SRVY) {
            return <Navigate to="/documents" replace />;
        }
        return <Navigate to="/applications" replace />;
    }

    return children;
};

export default RoleBasedRoute;
